import { ArrowBack } from '@mui/icons-material';
import { Divider, IconButton, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type UserAccessHeaderProps = {
  title: string;
  onBack: () => void;
};

export function UserAccessHeader({ title, onBack }: UserAccessHeaderProps) {
  const { t } = useTranslation();

  return (
    <>
      <Stack direction="row" alignItems="center" px={0.5} py={1}>
        <IconButton aria-label={t('userAccessControl.details.back')} onClick={onBack}>
          <ArrowBack />
        </IconButton>
        <Typography variant="h6" flex={1}>
          {title}
        </Typography>
      </Stack>
      <Divider />
    </>
  );
}
